export default __webpack_public_path__ + "images/auto_resize-dtbwc.png";